import { render, staticRenderFns } from "./EstimeTable.vue?vue&type=template&id=4bc207f8&scoped=true"
import script from "./EstimeTable.vue?vue&type=script&lang=js"
export * from "./EstimeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc207f8",
  null
  
)

export default component.exports